import React from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {differenceInDays} from 'date-fns/differenceInDays'
import {parseISO} from 'date-fns/parseISO'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {getSelectedAvailabilityDate} from 'modules/search/selectors'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {getCheckOutDate} from '@vio/core/src/searchParams/validateSearchParamDates'
import {dateStringToMiddayDate} from '@vio/core/src/utils/date'

const SelectedBannerWrapper = styled.div`
  background-color: ${cssTheme.colors.background.brand.secondary};
  color: ${cssTheme.colors.content.brand.primary};
  padding: ${cssTheme.layout.spacing.s250} ${cssTheme.layout.spacing.s500};
`

export const SelectedBanner = React.memo(function TopOffer() {
  const {formatDate} = useIntl()
  const {checkIn, checkOut} = useSelector(getSearchParameters)
  const selectedAvailabilityDate = useSelector(getSelectedAvailabilityDate)

  const nights = differenceInDays(parseISO(checkOut), parseISO(checkIn))
  const selectedCheckOutDate = getCheckOutDate(selectedAvailabilityDate, nights)

  return (
    <SelectedBannerWrapper>
      <Text variant="labelS">
        <FormattedMessageWrapper
          id="selectedDates"
          defaultMessage="Selected: {checkIn} - {checkOut}"
          values={{
            checkIn: formatDate(
              dateStringToMiddayDate(selectedAvailabilityDate),
              {
                day: '2-digit',
                month: 'short',
                weekday: 'short'
              }
            ),
            checkOut: formatDate(selectedCheckOutDate, {
              day: '2-digit',
              month: 'short',
              weekday: 'short'
            })
          }}
        />
      </Text>
    </SelectedBannerWrapper>
  )
})
